export const createDefaultProductContextValue = (defaultValue: any | undefined = undefined) => defaultValue;

export default createDefaultProductContextValue;
